import { createApiClient } from "./client";

export interface EmailSignature {
  id: string;
  workspaceId: string;
  teamId: string | null;
  name: string;
  content: string;
  isDefault: boolean;
  isTeamDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export function createSignaturesApi(token: string, workspaceId: string | null) {
  const client = createApiClient(token, workspaceId);
  return {
    list() {
      return client.get<{ signatures: EmailSignature[] }>("/email-signatures");
    },
  };
}

export function pickSignature(
  signatures: EmailSignature[],
  ticketTeamId: string | null | undefined
): EmailSignature | null {
  // Team-specific default first (matches web app behavior)
  if (ticketTeamId) {
    const teamDefault = signatures.find(
      (s) => s.teamId === ticketTeamId && s.isTeamDefault
    );
    if (teamDefault) return teamDefault;
  }
  // Fallback to agency default (no teamId, isDefault)
  return signatures.find((s) => !s.teamId && s.isDefault) ?? null;
}

interface AgentContext {
  displayName?: string;
  email?: string;
  role?: string;
  jobTitle?: string;
}

export function processSignaturePlaceholders(
  content: string,
  agent: AgentContext
): string {
  return content
    .replace(/\{\{agent\.name\}\}/g, agent.displayName ?? "")
    .replace(/\{\{agent\.jobTitle\}\}/g, agent.jobTitle ?? "")
    .replace(/\{\{agent\.email\}\}/g, agent.email ?? "")
    .replace(/\{\{agent\.role\}\}/g, agent.role ?? "");
}
